import {
    AddMember,
    ChangeMemberEmail,
    ChangeMemberJobTitle,
    ChangeMemberName,
    ChangeMemberPassword,
    ChangeMemberPrivatePhone,
    ChangeMemberPreferredLanguage,
    JobTitleItem,
    Member,
    MembersListResponse,
    MemberAccess, AddMemberWithoutPassword, ChangeAllowMarketingCommunication
} from '@/modules/members/types'
import { useAxiosModule } from '@/modules/_shared/axios'

const { postToApi, getFromApi, deleteInApi, patchToApi } = useAxiosModule()

export type GetMemberResponse = Member
export type GetMembersListResponse = MembersListResponse

export async function getMembersList (search = '', sortBy = 'id desc', limit = 0, offset = 0) {
    const queryParams = new URLSearchParams()
    queryParams.set('search', search)
    queryParams.set('sort', sortBy)
    queryParams.set('limit', String(limit))
    queryParams.set('offset', String(offset))
    const url = 'members?' + queryParams.toString()
    return getFromApi<GetMembersListResponse>(url)
}

export async function getMember (id: string) {
    return getFromApi<GetMemberResponse>(`members/${id}`)
}

export type AddMemberRequest = AddMember
export type AddMemberRequestWithoutPassword = AddMemberWithoutPassword

export async function addMemberWithoutAuthenticationProfile (req: AddMemberRequestWithoutPassword) {
    return postToApi<{ memberId: string }>('members/without-authentication-profile', req)
}

export async function addMemberWithPasswordProfile (req: AddMemberRequest) {
    return postToApi<{ memberId: string }>('members/with-password-profile', req)
}

export async function deleteSingleMember (id: string) {
    return deleteInApi<null>(`members/${id}`, { memberId: id })
}

const findMemberUrl = 'members/find-by-phrase' // NOTE: no such endpoint -----------

export async function findMember (phrase: string) {
    return postToApi<null>(findMemberUrl, phrase)
}

/* Change email */

export type UpdateMemberEmailRequest = ChangeMemberEmail
export async function updateSingleMemberEmail (id: string, req: UpdateMemberEmailRequest) {
    return patchToApi<null>(`members/${id}/change-email`, req)
}

/* Change name */

export type UpdateMemberNameRequest = ChangeMemberName
export async function updateSingleMemberName (id: string, req: UpdateMemberNameRequest) {
    return patchToApi<null>(`members/${id}/change-name`, req)
}

/* Change password */

export type UpdateMemberPasswordRequest = ChangeMemberPassword
export async function updateSingleMemberPassword (id: string, req: UpdateMemberPasswordRequest) {
    return patchToApi<null>(`members/${id}/change-password-profile`, req)
}

/* Change private phone */

export type UpdateMemberPhoneRequest = ChangeMemberPrivatePhone
export async function updateSingleMemberPhone (id: string, req: UpdateMemberPhoneRequest) {
    return patchToApi<null>(`members/${id}/change-phone`, req)
}

/* Update job title */

export type UpdateMemberJobTitleRequest = ChangeMemberJobTitle
export async function updateSingleMemberJobTitle (id: string, req: UpdateMemberJobTitleRequest) {
    return patchToApi<null>(`members/${id}/change-job-title`, req)
}

/* Update preferred language */
export type UpdateMemberPreferredLanguageRequest = ChangeMemberPreferredLanguage
export async function updateSingleMemberPreferredLanguage (id: string, req: UpdateMemberPreferredLanguageRequest) {
    return patchToApi<null>(`members/${id}/change-preferred-language`, req)
}

export type updateMemberPermissionForMarketingRequest = ChangeAllowMarketingCommunication
export async function updateSingleMemberPermissionForMarketing (id: string, req: updateMemberPermissionForMarketingRequest) {
    return patchToApi<null>(`members/${id}/change-allow-marketing-communication`, req)
}

type MemberAccessesResponse = MemberAccess[]
export async function getMemberAccesses (id: string) {
    return getFromApi<MemberAccessesResponse>(`content-access/member/${id}`)
}
